const DEMO_PROMPTS = [
  {
    prompt: "Best movies in theaters right now",
    choices: [
      "Wicked: For Good",
      "Thunderbolts*",
      "Lilo & Stitch",
      "Mission: Impossible 8",
      "The Fantastic Four",
      "Karate Kid: Legends",
    ],
    tags: ["Smart AI", "Web Search"],
  },
  {
    prompt: "Coffee shops in my neighborhood",
    choices: [
      "Blue Bottle Coffee",
      "Verve Coffee Roasters",
      "Philz Coffee",
      "Stumptown Roasters",
      "Sightglass Coffee",
      "Equator Coffees",
    ],
    tags: ["Web Search", "Precise Location"],
  },
  {
    prompt: "Unique birthday party themes",
    choices: [
      "80s Neon Arcade",
      "Murder Mystery Dinner",
      "Botanical Garden Brunch",
      "Glow-in-the-Dark Mini Golf",
      "Rooftop Cinema Night",
      "Vintage Carnival",
    ],
    tags: ["Smart AI"],
  },
  {
    prompt: "Hiking trails near me",
    choices: [
      "Lands End Trail",
      "Twin Peaks Loop",
      "Batteries to Bluffs",
      "Mount Sutro Forest",
      "Glen Canyon Park",
      "Bernal Heights Hill",
    ],
    tags: ["Web Search", "Precise Location"],
  },
  {
    prompt: "Trending cocktails to try this year",
    choices: ["Espresso Martini", "Spicy Margarita", "Paper Plane", "Dirty Shirley", "Ranch Water", "Aperol Spritz"],
    tags: ["Smart AI", "Web Search"],
  },
  {
    prompt: "Where should we go for dinner tonight",
    choices: ["Osteria Mozza", "Bestia", "Guisados", "Howlin' Ray's", "Musso & Frank Grill", "Sonoratown"],
    tags: ["Smart AI", "Web Search", "Precise Location"],
  },
]

export default DEMO_PROMPTS
